import { SESSION_SLICE_NAME } from 'app/modules/session/sliceSession';

export const selectLoadingPermissions = (state: RootState) =>
  state[SESSION_SLICE_NAME].loadingPermissions;
